/**
 * How a finding's severity LOOKS in the admin console — the only thing about severity
 * this app gets to decide. What severity *means* (1 = critical … 5 = low, which end is
 * worse, how to weight it) belongs to @padcanvas/shared/agentSeverity; import from there
 * rather than re-deriving it here.
 */
import { AGENT_SEVERITY_LABELS, MOST_SEVERE, type AgentSeverity } from '@padcanvas/shared';

/** Badge colour: critical/major read as error, moderate warns, the mild end stays plain. */
export function sevVariant(sev: number): 'error' | 'warning' | 'default' {
  if (sev <= MOST_SEVERE + 1) return 'error';
  return sev === MOST_SEVERE + 2 ? 'warning' : 'default';
}

/** "2 (major)" — the number alone doesn't say which direction is bad. Digests written
 *  before the severityWorst rename carry no value, hence the em-dash rather than
 *  "undefined"; regenerating the digest fills them in. */
export function sevLabel(sev: number | undefined): string {
  if (!Number.isFinite(sev)) return '—';
  const name = AGENT_SEVERITY_LABELS[sev as AgentSeverity];
  return name ? `${sev} (${name})` : String(sev);
}
